"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _l10n = require("../../../l10n");
var _fetchLinkForResetPassword = _interopRequireDefault(require("../../../utils/fetchLinkForResetPassword"));
var _AlertingBannerModal = _interopRequireDefault(require("../AlertingBannerModal/AlertingBannerModal"));
const ChangePasswordModal = _ref => {
  let {
    onClose,
    ModalComp,
    locale,
    bffUrl
  } = _ref;
  const title = (0, _l10n.getMessages)(locale)('ChangePasswordModal.changePassword');
  const changePasswordInfo = (0, _l10n.getMessages)(locale)('ChangePasswordModal.info');
  const getLinkForResetPassword = async () => {
    try {
      const linkFetch = (0, _fetchLinkForResetPassword.default)({
        bffUrl
      });
      const fetchedLink = await linkFetch;
      return fetchedLink;
    } catch (e) {
      return null;
    }
  };
  const handleOnContinue = async () => {
    const ticket = await getLinkForResetPassword();
    if (ticket) {
      window.open(ticket, '_self');
    }
    onClose();
  };
  return /*#__PURE__*/_react.default.createElement(_AlertingBannerModal.default, {
    testId: "change-password-modal",
    title: title,
    bodyMessages: [changePasswordInfo],
    footerButtonsText: [(0, _l10n.getMessages)(locale)('General.Cancel'), (0, _l10n.getMessages)(locale)('General.Continue')],
    onClose: onClose,
    ModalComp: ModalComp,
    onContinue: handleOnContinue
  });
};
var _default = exports.default = ChangePasswordModal;